import ErrorHandler from './error_handler';
import Splunk from '../report/splunk';
import LanguageManager from '../language_manager/language_manager';

/**
 * Handling errors from external clients, e.g. the starzplayer wrapper.
 */
export default {

    throwError(options, developerMessage) {
        // If minimum splunk actions are available
        if (this.splunkOptions && Object.keys(this.splunkOptions).length > 0 && this.splunkOptions.sessionToken) {
            Splunk.addOptions(this.splunkOptions);
        } else {
            options.logSplunk = false;
        }

        ErrorHandler.throwError(options, developerMessage);
    },

    /**
     * Add client options
     * @param {Object} options
     * @param {string} options.language
     * @param {string} options.feed
     * @param {string} options.videoType
     * @param {string} options.sessionToken
     * @param {Object} options.clientConfiguration
     * @param {string} options.userId
     * @param {string} options.environment
     */
    addOptions(options) {
        if (typeof options !== 'object') return;

        // LanguageManager
        if (options.language) {
            this.language = options.language;
            LanguageManager.setLanguage(this.language || 'en');
        }

        // Splunk
        this.splunkOptions = {
            userId: options.userId,
            feed: options.feed,
            videoType: options.videoType,
            sessionToken: options.sessionToken,
            clientConfiguration: options.clientConfiguration
        };
    }
};



// WEBPACK FOOTER //
// ./src/modules/error_handler/external_error_handler.js